// extracted by mini-css-extract-plugin
module.exports = {"title":"ScheduleScreen_title__3Uz1G"};